/**
 * Keeps a fixed PDF copy of an invoice in the private bucket (Cloudflare R2 / S3), so the copy a
 * client received does not change when the invoice is regenerated later.
 */
import axiosInstance from "../components/api/axiosInstance";
import { generateInvoicePdfBlob } from "./invoicePdf";
import { putToSignedUrl } from "./directUpload";

/**
 * Render `pdfData` (shape of `generateInvoicePdf`) and store it as the invoice's `docType`
 * ("Issued" or "Cancelled") copy. Resolves with the stored document, or null when storage failed;
 * archiving never blocks the invoice action that triggered it.
 */
export async function archiveInvoicePdf(arId, pdfData, docType = "Issued") {
  if (!arId || !pdfData) return null;
  try {
    const blob = generateInvoicePdfBlob(pdfData);
    const res = await axiosInstance.post(`/fico/accounts-receivable/${arId}/documents/upload-url`, {
      Doc_Type: docType,
      size: blob.size
    });
    const { document, upload } = res.data || {};
    await putToSignedUrl({ ...upload, file: blob });
    const done = await axiosInstance.post(`/fico/ar-documents/${document.Doc_Id}/complete`);
    return done.data || null;
  } catch (err) {
    console.warn("Could not store the invoice PDF copy:", err?.response?.data?.error || err?.message || err);
    return null;
  }
}

/**
 * Download a stored copy through its signed link; false when there is none. The link is signed
 * with an attachment disposition, so following it downloads without leaving the page (and is not
 * caught by popup blockers after an await, unlike window.open).
 */
export function openStoredInvoicePdf(doc) {
  const url = doc?.Download_Url;
  if (!url) return false;
  const a = document.createElement("a");
  a.href = url;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
  return true;
}
